import {
    GET_vCard,
    LOADING_vCard,
    vCard_ERROR
  } from "../../../actions/core/vCard/vCard";
  
const initialState = {loading:false,fail:false, fields:''};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_vCard:
      return {
        ...state,
        fail:false,
        loading: true
      };
    case GET_vCard:
      //console.log('reducer getVCard', action)
      return {
        ...state,
        loading: false,
        fail:false,
        fields: action.fields
      };
    case vCard_ERROR:
      return {
        ...state,
        loading: false,
        fail:true,
        error: action.error
      };
    default:
      return state;
  }
};
